import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';
import { ClassificationEdit } from '../../_models/classificationEdit';
import { HttpClient } from '@angular/common/http';
import { ClassificationInfo } from '../../_models/classificationInfo';
import { ClassificationView } from 'src/app/_models/classificationView';
import { ClassificationForFilter } from '../../_models/classificationForFilter';

@Injectable({
   providedIn: 'root',
})
export class ClassificationService {
   baseUrl = environment.apiUrl;
   classSelected = new Subject<ClassificationInfo>();
   viewClassSelected = new Subject<ClassificationInfo>();
   ImportSelected = new Subject<ClassificationInfo>();
   popupClassSelected = new Subject<ClassificationInfo>();
   constructor(private http: HttpClient) {}

   changeEditState(c: ClassificationInfo) {
      this.classSelected.next(c);
   }
   changeViewState(c: ClassificationInfo) {
      this.viewClassSelected.next(c);
   }
   changeImportState(c: ClassificationInfo) {
      this.ImportSelected.next(c);
   }
   changePopupState() {
      this.popupClassSelected.next(null);
   }
   getClassificationsUsedOnAssets(): Observable<ClassificationForFilter[]> {
      return this.http.get<ClassificationForFilter[]>(this.baseUrl + 'classification/getclassificationsusedonassets');
   }
   getClassifications(): Observable<ClassificationInfo[]> {
      return this.http.get<ClassificationInfo[]>(this.baseUrl + 'classification');
   }
   getClassificationsComponentTypeLevel(): Observable<ClassificationEdit[]> {
      return this.http.get<ClassificationEdit[]>(this.baseUrl + 'classification/componenttypelevel');
   }
   getClassificationsAdvanced(): Observable<ClassificationEdit[]> {
      return this.http.get<ClassificationEdit[]>(this.baseUrl + 'classification/advanced');
   }
   getClassification(id): Observable<ClassificationEdit> {
      return this.http.get<ClassificationEdit>(this.baseUrl + 'classification/' + encodeURIComponent(id));
   }
   getClassificationByComponentTypeCode(componentTypeCode): Observable<ClassificationEdit> {
      return this.http.get<ClassificationEdit>(this.baseUrl + 'classification/componentcode/' + encodeURIComponent(componentTypeCode));
   }
   getClassificationView(id): Observable<ClassificationView> {
      return this.http.get<ClassificationView>(this.baseUrl + 'classification/view/' + encodeURIComponent(id));
   }
   updateClassification(id: string, c: ClassificationEdit) {
      return this.http.put(this.baseUrl + 'classification/' + encodeURIComponent(id), c);
   }
   createClassification(c: ClassificationEdit) {
      return this.http.post(this.baseUrl + 'classification', c);
   }
   deleteClassification(id: string) {
      return this.http.delete(this.baseUrl + 'classification/' + encodeURIComponent(id));
   }
   export(OnlyTemplate: boolean): Observable<Blob> {
      // tslint:disable-next-line:max-line-length
      return this.http.get(this.baseUrl + 'classification/export/' + OnlyTemplate, {
         responseType: 'blob',
      });
   }
}
